import type { MarketplaceKey } from "@porsche-customer/slfinrtl-context-types"
import type { FlagName } from "@porsche-design-system/components-react"

// Marketplaces without a flag in the Porsche Design System
const marketplacesWithoutFlag: ReadonlySet<MarketplaceKey> = new Set(["gp", "nc", "xa", "xd", "xp"])

export const getMarketplaceFlagName = (marketplaceKey: MarketplaceKey): FlagName =>
	marketplacesWithoutFlag.has(marketplaceKey) ? "xx" : (marketplaceKey as FlagName)
